import { render, staticRenderFns } from "./SiteRouteEdit.vue?vue&type=template&id=60c92b11"
import script from "./SiteRouteEdit.vue?vue&type=script&lang=js"
export * from "./SiteRouteEdit.vue?vue&type=script&lang=js"
import style0 from "./SiteRouteEdit.vue?vue&type=style&index=0&id=60c92b11&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports